import { useState } from 'react';

import { Button, Icon, useToast } from '@/components/ui';
import { errorMessage } from '@/hooks/useApiError';

/**
 * Saves one invoice as a PDF.
 *
 * `download` is the api function for the caller's side — the student's, the
 * company's or the admin's route — so every table uses the same button.
 *
 * A small labelled ghost "Download": it sits in an invoice table's action
 * cell, so it stays quiet and compact, but says what it does. The accessible
 * name keeps the invoice number, so a screen reader can tell the rows apart.
 */
export function InvoiceDownloadButton({ invoice, download }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    try {
      await download(invoice);
    } catch (error) {
      toast.error(errorMessage(error));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button
      variant="ghostBrand"
      size="xs"
      aria-label={`Download invoice ${invoice.number}`}
      title={`Download invoice ${invoice.number}`}
      isLoading={busy}
      onClick={() => void save()}
    >
      {!busy && <Icon name="download" size={14} />}
      Download
    </Button>
  );
}
